import {Injectable} from '@angular/core';
import {ArrayUtils} from "@ispm/shared/utils/Array.utils";
import {ObjectUtils} from "@ispm/shared/utils/Object.utils";

@Injectable()
export class ObjectWalkService {

    constructor() {
    }

    public walk(input, path) {
        if (input) {
            if (Array.isArray(input)) {
                return ArrayUtils.walk(input, path);

            } else {
                return ObjectUtils.walk(input, path);
            }
        }
    }

}
